export const HEALTH_LIFESTYLE_DATA_REQUEST = 'HEALTH_LIFESTYLE_DATA_REQUEST';
export const HEALTH_LIFESTYLE_DATA_SUCCESS = 'HEALTH_LIFESTYLE_DATA_SUCCESS';
export const HEALTH_LIFESTYLE_DATA_FAIL = 'HEALTH_LIFESTYLE_DATA_FAIL';
